import { useState } from 'react'
import { Mail, Phone, X, CheckCircle } from 'lucide-react'
import { useAuthStore } from '../store/authStore'
import OTPVerification from './OTPVerification'
import toast from 'react-hot-toast'

export default function VerificationBanner() {
  const { userData, user, resendEmailVerification, checkEmailVerification } = useAuthStore()
  const [showOTPModal, setShowOTPModal] = useState(false)
  const [dismissed, setDismissed] = useState({
    email: false,
    phone: false,
  })

  if (!userData) return null

  const emailNotVerified = !userData?.emailVerified && !dismissed.email
  const phoneNotVerified = !userData?.phoneVerified && !dismissed.phone

  if (!emailNotVerified && !phoneNotVerified) return null

  const handleResendEmail = async () => {
    await resendEmailVerification()
  }

  const handleCheckEmail = async () => {
    const verified = await checkEmailVerification()
    if (verified) {
      toast.success('¡Email verificado correctamente!')
    } else {
      toast.error('Aún no has verificado tu email. Revisa tu bandeja de entrada.')
    }
  }

  const handleVerifyPhone = () => {
    setShowOTPModal(true)
  }

  const handleOTPVerified = () => {
    // La verificación ya se hizo en authStore.verifyPhoneOTP
    setShowOTPModal(false)
    toast.success('¡Teléfono verificado!')
  }

  return (
    <>
      <div className="bg-gradient-to-r from-yellow-50 to-orange-50 border-b border-yellow-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
          <div className="flex flex-col gap-3">
            {/* Email Verification Alert */}
            {emailNotVerified && (
              <div className="flex items-center justify-between bg-white rounded-lg p-3 shadow-sm">
                <div className="flex items-center gap-3 flex-1">
                  <Mail className="text-yellow-600" size={20} />
                  <div className="flex-1">
                    <p className="text-sm font-medium text-gray-900">
                      Verifica tu correo electrónico
                    </p>
                    <p className="text-xs text-gray-600">
                      Te enviamos un enlace de verificación a {user?.email}.<br />
                      <span className="text-xs text-yellow-700">Si no lo ves en tu bandeja de entrada, revisa tu carpeta de correo no deseado o spam.</span>
                    </p>
                  </div>
                  <div className="flex gap-2">
                    <button
                      onClick={handleCheckEmail}
                      className="text-xs btn btn-primary py-1 px-3"
                    >
                      Ya verifiqué
                    </button>
                    <button
                      onClick={handleResendEmail}
                      className="text-xs btn btn-secondary py-1 px-3"
                    >
                      Reenviar
                    </button>
                  </div>
                </div>
                <button
                  onClick={() => setDismissed({ ...dismissed, email: true })}
                  className="ml-3 text-gray-400 hover:text-gray-600"
                >
                  <X size={18} />
                </button>
              </div>
            )}

            {/* Phone Verification Alert */}
            {phoneNotVerified && (
              <div className="flex items-center justify-between bg-white rounded-lg p-3 shadow-sm">
                <div className="flex items-center gap-3 flex-1">
                  <Phone className="text-yellow-600" size={20} />
                  <div className="flex-1">
                    <p className="text-sm font-medium text-gray-900">
                      Verifica tu número de teléfono
                    </p>
                    <p className="text-xs text-gray-600">
                      Necesitas verificar tu teléfono para realizar retiros
                    </p>
                  </div>
                  <button
                    onClick={handleVerifyPhone}
                    className="text-xs btn btn-primary py-1 px-3"
                  >
                    Verificar ahora
                  </button>
                </div>
                <button
                  onClick={() => setDismissed({ ...dismissed, phone: true })}
                  className="ml-3 text-gray-400 hover:text-gray-600"
                >
                  <X size={18} />
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* OTP Modal */}
      {showOTPModal && (
        <OTPVerification
          phoneNumber={userData.phone}
          onVerified={handleOTPVerified}
          onCancel={() => setShowOTPModal(false)}
        />
      )}
    </>
  )
}
